import { Localization } from "@viamap/viamap2-common";
import { LayerInfo } from "src/common/managers/Types";
import { Fragment, useContext, useState } from "react";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton } from "./GlassButtons";
import { actionAddDataLayer, MapitStateContext } from "src/states/MapitState";


type Props = {
  showWindow: number;
  layers?: LayerInfo | LayerInfo[]
  onClose: () => void;
};
export function NameOnCreation(props: Props) {
  const { dispatch: mapitStateDispatch } = useContext(MapitStateContext);

  let layers = !props.layers ? [] : "type" in props.layers ? [props.layers] : props.layers
  const [name, setName] = useState(layers.map((a) => a.datasetname))

  function updateName(value: string, idx: number) {
    setName((name) => name.map((a, idy) => idx === idy ? (value ?? "") : a))
  }

  function Accept() {
    let newLayers = layers.map((layer, idx) => ({
      ...layer,
      datasetname: name[idx] || layer.datasetname
    }))
    newLayers.forEach((layer) => {
      mapitStateDispatch(actionAddDataLayer(layer as any));
    })
    props.onClose()
  }

  function Cancel() {
    props.onClose()
  }


  return <AdvancedDragModal
    PosDefault={{ left: "50%", top: "10%", transform: "translateX(-50%)", width: "500px" }}
    title={Localization.getText("Rename")}
  >
    <ADModalInfo>
      {name.length < 2 ? Localization.getText("Change the name of new the layer before adding it to the list") : Localization.getText("Change the names of the new layers before they are added to the list")}
    </ADModalInfo>
    <ADModalBody>
      {layers.map((layer, idx) => {
        return (<Fragment key={layer.datasetname ?? "Error"}>
          <div style={{ color: "grey", textAlign: "left", fontSize: "11px" }}>{Localization.getText("Layer") + ": " + (idx + 1)}</div>
          <input autoFocus={idx == 0} style={{ color: "black", paddingLeft: "6px" }} type="text" value={name[idx]} placeholder={layer.datasetname ?? "Error"} onChange={(ev) => updateName(ev.target.value, idx)}
            onKeyDown={(e) => {
              (idx == 0 && e.code == "Enter" && Accept());
              (layers.length - 1 == idx && e.code == "Escape" && Cancel());
            }}
          />
        </Fragment>)
      })}
    </ADModalBody>
    <ADModalFooter>
      <GlassButton onClick={() => Accept()}>{Localization.getText("Save")}</GlassButton>
      <GlassButton onClick={() => Cancel()}>{Localization.getText("Close")}</GlassButton>
    </ADModalFooter>
  </AdvancedDragModal>
}